import {
  Box,
  ClickAwayListener,
  Divider,
  IconButton,
  Modal,
  Typography,
  makeStyles
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { Color, DragNSelectCalendar, UnfoldLessIcon } from "@bonliva-crm/ui";
import { useState } from "react";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (weeks: Date[]) => void;
};

export const ExpandedViewModal = (props: Props) => {
  const classes = useStyles({});
  const [initalYear, setInitialYear] = useState<number>(new Date().getFullYear());

  return (
    <Modal open={props.open} className={classes.modal}>
      <ClickAwayListener onClickAway={props.onClose}>
        <Box className={classes.modalContent}>
          <Box className={classes.modalTopWrapper}>
            <Typography className={classes.title}>{locale.Availability}</Typography>
            <IconButton onClick={props.onClose} className={classes.closeButton}>
              <UnfoldLessIcon
                style={{
                  margin: "0 8px 8px 0 "
                }}
              />
            </IconButton>
          </Box>

          <Box className={classes.modalBorderWrapper}>
            <Box className={classes.modalActionWrapper}>
              <IconButton
                className={classes.yearChangeButton}
                onClick={() => setInitialYear((prev) => prev - 1)}
              >
                <ChevronLeft htmlColor={Color.Body} />
              </IconButton>

              <Typography
                color="primary"
                variant="body2"
                style={{
                  marginRight: "6rem"
                }}
              >
                {initalYear}
              </Typography>

              <Typography
                color="primary"
                variant="body2"
                style={{
                  marginLeft: "6rem"
                }}
              >
                {initalYear + 1}
              </Typography>

              <IconButton
                className={classes.yearChangeButton}
                onClick={() => setInitialYear((prev) => prev + 1)}
              >
                <ChevronRight htmlColor={Color.Body} />
              </IconButton>
            </Box>
            <Box className={classes.modalCalendarWrapper}>
              <DragNSelectCalendar
                hideYearNumber
                upcomingWorkplaces={[]}
                initialDate={new Date(`${initalYear}-01-01`)}
                preSelectedDates={[]}
                onSelect={props.onSelect}
              />
              <Divider orientation="vertical" flexItem />
              <DragNSelectCalendar
                hideYearNumber
                upcomingWorkplaces={[]}
                initialDate={new Date(`${initalYear + 1}-01-01`)}
                preSelectedDates={[]}
                onSelect={props.onSelect}
              />
            </Box>
            {/*<ColorDescription alignLeft />*/}
          </Box>
        </Box>
      </ClickAwayListener>
    </Modal>
  );
};

const useStyles = makeStyles(() => ({
  title: {
    textTransform: "uppercase",
    color: Color.DetailsInput
  },
  modal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    height: "100%",
    width: "100%",
    padding: "2rem"
  },
  modalContent: {
    backgroundColor: "white",
    padding: "1rem",
    borderRadius: "2px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: "3.5rem"
  },
  modalCalendarWrapper: {
    width: "40rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    gap: "1rem"
  },
  modalTopWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "1rem"
  },
  modalActionWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  modalBorderWrapper: {
    border: `1px solid ${Color.LightGray}`,
    borderRadius: "2px",
    padding: "0 1rem",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },
  yearChangeButton: {
    border: `1px solid ${Color.LightGray}`,
    borderRadius: "6px",
    padding: "2px",
    margin: "1rem 0"
  },
  closeButton: {
    padding: 0
  }
}));
